import { create } from 'zustand'

import type { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'

import type { TPublicationToShare } from '../ui/components/PublicationShareModal'

type TPublicationShareStore = {
  publication: TPublicationToShare | null
  trackingSource?: TRACKING_SOURCE
  open: (publication: TPublicationToShare, trackingSource: TRACKING_SOURCE) => void
  close: () => void
}

export const usePublicationShareStore = create<TPublicationShareStore>()((set) => ({
  publication: null,
  trackingSource: undefined,
  open: (publication, trackingSource) => set({ publication, trackingSource }),
  close: () => set({ publication: null, trackingSource: undefined }),
}))
